import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const groupEntityAdapter: EntityAdapter = {
  entity: "group",
  defaultSort: { sort: "name", tableSort: "name", descending: false },
};
